import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['output']
  static values = { url: String }

  connect() {
    this.fetchPartial();
  }

  fetchPartial = async () => {
    const request = new Request(this.urlValue);

    try {
      const response = await fetch(request)
      const content = await response.text();
      this.outputTarget.innerHTML = await content;
    } catch (error) {
      console.log(error);
    }
  }
}
